import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BindInfoComponent } from './bind-info.component';
import { PageHeaderNavigationComponent } from '../shared/page-step-nav/page-header-navigation/page-header-navigation';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreInputsModule } from '@tmhcc-ng-lib/framwork/core-inputs';
import { PageStepNavModule } from '../shared/page-step-nav/page-step-nav.module';

const routes: Routes = [
  {
    path: '',
    component: BindInfoComponent
    //canDeactivate: [UnsavedDataGaurd]
  }
];

@NgModule({
  declarations: [BindInfoComponent],
  imports: [
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    CoreInputsModule,
    CommonModule,
    PageStepNavModule
  ],
  exports: [RouterModule]
})
export class BindInfoModule {}
